import { SSRPrepareErrorsClient } from '../src/SSRPrepareErrorsClient.ts';

export const ssrPrepareErrorsClient: SSRPrepareErrorsClient = new SSRPrepareErrorsClient();
